import { socketUpdateWatchHistory } from "@/socket";
import actions from "@/store/actions";
import utils from "@/utils";
import api from "@/api";

export const fetchHistory = (user) => {
  return async (dispatch) => {
    if (utils.getCookie("login_state") || user?.email) {
      const res = await api.getUserWatchHistory(user?._id);
      if (res.status === 200) {
        dispatch(actions.historyActions.fetchwatchhistory(res.data?.result));
        return;
      }
    }
    dispatch(actions.historyActions.fetchwatchhistory([]));
  };
};

export const updateWatchHistory = (history, socket, userId) => {
  return async (dispatch) => {
    // console.log("Socket Called history", history);
    socketUpdateWatchHistory(
      {
        userId: userId,
        history: history,
      },
      socket
    );

    dispatch(actions.historyActions.updatehistory(history));
    return;
  };
};
